export const COOKIES = {
  PHONE_LOGIN: "_pl",
  AUTHED: "_authed",
  AUTH_UUID: "_diuuhtua",
  AUTH_INFO: "_authinfo",
  STORE_VISIT_ID: "_svid",
  SALES_ORDER_ID: "_soid",
};
